import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Gift, Heart, ShoppingCart } from "lucide-react";

const ComboGiftCard = ({ combo, index }) => {
  const formattedPrice = combo.price ? `₹${combo.price.toLocaleString()}` : 'Price on request';
  const imageUrl = combo.images?.[0] || "https://via.placeholder.com/300";

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: index * 0.1 }}
      className="group relative bg-white rounded-sm shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100"
    >
      {/* Featured Badge */}
      {combo.is_featured && (
        <div className="absolute top-3 left-3 z-10 bg-gradient-to-r from-[#D4AF37] to-[#C19B2E] text-white text-xs font-medium px-3 py-1 rounded-full">
          Featured
        </div>
      )}

      {/* Gift Icon */}
      <div className="absolute top-3 right-3 z-10 opacity-70 group-hover:opacity-100 transition-opacity duration-300">
        <Gift className="h-6 w-6 text-[#D4AF37]" />
      </div>

      {/* Image Container */}
      <div className="relative overflow-hidden h-64 bg-gradient-to-br from-gray-50 to-gray-100">
        <img
          src={imageUrl}
          alt={combo.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
          loading="lazy"
        />
        
        {/* Overlay on Hover */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        
        {/* Quick Action Buttons */}
        <div className="absolute bottom-3 right-3 flex gap-2 opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-y-2 group-hover:translate-y-0">
 
          <button
            className="bg-[#D4AF37] hover:bg-[#C19B2E] text-white p-2 rounded-full shadow-md hover:shadow-lg transition-all duration-200"
            aria-label="Quick add to cart"
          >
            <ShoppingCart className="h-4 w-4" />
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="p-5">
        <div className="mb-3">
          <h3 className="text-lg font-semibold text-[#333333] mb-2 group-hover:text-[#D4AF37] transition-colors duration-300 line-clamp-2">
            {combo.title}
          </h3>
          <p className="text-sm text-gray-500 line-clamp-2">
            {combo.description}
          </p>
        </div>

        {/* Product ID */}
        <div className="mb-3">
          <span className="text-xs text-[#D4AF37] font-medium bg-[#D4AF37]/10 px-2 py-1 rounded-full">
            ID: {combo.id}
          </span>
        </div>

        {/* Price and CTA */}
        <div className="flex items-center justify-between">
          <div>
            <span className="text-lg font-bold text-[#333333]">
              {formattedPrice}
            </span>
          </div>
          <Link
            to={`/combo-gifts/${combo._id}`}
            state={{ comboData: combo }}
            className="bg-gradient-to-r from-[#D4AF37] to-[#C19B2E] text-white px-4 py-2 rounded-sm text-sm font-medium hover:from-[#C19B2E] hover:to-[#B08927] transition-all duration-200 transform hover:scale-105 shadow-md hover:shadow-lg"
          >
            View Details
          </Link>
        </div>
      </div>

      {/* Bottom Accent Line */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
    </motion.div>
  );
};

export default ComboGiftCard;